import {Grid} from "@mui/material";
import { MainCategoryContainerStyled, CategoryContainerStyled, CategoryHeaderStyled, CategoryHeaderArStyled,  CategorySubHeaderStyled, CategorySubHeaderArStyled, CategoryGridStyled, ItemContainerStyled, ItemImageContainer, ItemBoxTwoStyled, ItemDetailsContainer, ItemDetailsArStyled,  ItemDetailsStyled, ItemPriceContainer, ItemPriceContainerAr, ItemNameStyled, ItemNameArStyled } from "./generalStyles";


function SoftDrinksWater({triggerLanguage, categoryItems}) {
    
    // const reversedPairs = sharingPlates.reduce((acc, _, index, arr)=> {
    //     if(index %2 === 1) {
    //         acc.push(arr[index], arr[index-1]);
    //     }
    //     return acc
    // }, []);

    if(triggerLanguage == "en") {

        return (
            <MainCategoryContainerStyled>
                <CategoryContainerStyled>
                    <span>SOFT DRINKS & WATER </span>
                </CategoryContainerStyled>
                <CategoryGridStyled>
                    <Grid container spacing = {2} rowSpacing = {4}>
                        {categoryItems.map(({name_en, description_en, price, image}) => {
                            return (
                                <Grid item xs = {6} sm = {6}>
                                    <ItemContainerStyled>
                                        <ItemImageContainer>
                                            <img src = {image}/>
                                        </ItemImageContainer>
                                            <ItemBoxTwoStyled>
                                                <ItemDetailsContainer>
                                                    <div>
                                                        <ItemNameStyled>
                                                                {name_en}
                                                        </ItemNameStyled>
                                                        <ItemDetailsStyled>{description_en}</ItemDetailsStyled>
                                                    </div>
                                                </ItemDetailsContainer>
                                                <ItemPriceContainer>
                                                    {price} <span>QR</span>
                                            </ItemPriceContainer>
                                        </ItemBoxTwoStyled>
                                    </ItemContainerStyled>
                                </Grid>
                            )
                        })}
                    </Grid>
                </CategoryGridStyled>
            </MainCategoryContainerStyled>
        )
    }

    // if(triggerLanguage == "ar") {
    //     return (
    //           <MainCategoryContainerStyled>
    //             <CategoryContainerStyled>
    //                 <CategoryHeaderArStyled>
    //                 </CategoryHeaderArStyled>
    //                 {/* <CategorySubHeaderStyled>
    //                     Sub Header one
    //                 </CategorySubHeaderStyled> */}
    //                 <CategoryGridStyled>
    //                     <Grid container spacing = {2} rowSpacing = {4}>
    //                     {
    //                         sharingPlates.map(({name_ar, description_ar, price, image}) => {
    //                             return (
    //                                 <Grid item xs = {6} sm = {6}>
    //                                     <ItemContainerStyled>
    //                                         <ItemImageContainer>
    //                                             <img src = {image} />
    //                                         </ItemImageContainer>
    //                                         <ItemBoxTwoStyled>
    //                                             <ItemPriceContainerAr>
    //                                                 <div>{price}</div>
    //                                                 <div><span>ر.ق</span></div>   
    //                                             </ItemPriceContainerAr>
    //                                             <ItemDetailsContainer style = {{textAlign: "right"}}>
    //                                                 <div>
    //                                                     <ItemNameArStyled>
    //                                                         {name_ar}
    //                                                     </ItemNameArStyled>
    //                                                     <ItemDetailsArStyled>{description_ar}</ItemDetailsArStyled>
    //                                                 </div>
    //                                             </ItemDetailsContainer>
    //                                         </ItemBoxTwoStyled>
    //                                     </ItemContainerStyled>
    //                                 </Grid>
    //                             )
    //                         })
    //                     }
    //                     </Grid>
    //                 </CategoryGridStyled>
    //             </CategoryContainerStyled>
    //         </MainCategoryContainerStyled>
    //     )
      
    // }
}

export default SoftDrinksWater;